// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"446":"fee63dbc","586":"d53b8559","948":"a049cedd"}[chunkId] + ".chunk.js";
};